<app-web-templates-container #container [title]="'Web Templates'">
  <app-tab-bar
    #tabController
    [tabs]="viewModel.tabs$ | async"
    (selectedTab)="container.tabSelected($event)"></app-tab-bar>
</app-web-templates-container>
